import type CodableTag from '@src/service/model/CodableTag'

// eslint-disable-next-line import-x/no-restricted-paths
import { OdysseyAnalyticsBridge } from '@odyssey/analytics/OdysseyAnalyticsBridge'

export default class AiCallTagsAnalyticsStore {
  private readonly analytics: typeof OdysseyAnalyticsBridge

  constructor() {
    this.analytics = OdysseyAnalyticsBridge
  }

  callTagClickedOnChatsView(tag: CodableTag) {
    void this.analytics.track('call_tag_clicked_chats_view', { tagName: tag.name })
  }

  callTagClickedOnCallsView(tag: CodableTag) {
    void this.analytics.track('call_tag_clicked_calls_view', { tagName: tag.name })
  }

  viewCallsWithTagOnChatsView(tag: CodableTag) {
    void this.analytics.track('view_calls_with_tag_chats_view', { tagName: tag.name })
  }

  viewCallsWithTagOnCallsView(tag: CodableTag) {
    void this.analytics.track('view_calls_with_tag_calls_view', { tagName: tag.name })
  }

  viewCallsWithTagOnSettings(tag: CodableTag) {
    void this.analytics.track('view_calls_with_tag_settings', { tagName: tag.name })
  }

  goToTagSettingsOnChatsView(tag: CodableTag) {
    void this.analytics.track('go_to_tag_settings_chats_view', { tagName: tag.name })
  }

  goToTagSettingsOnCallsView(tag: CodableTag) {
    void this.analytics.track('go_to_tag_settings_calls_view', { tagName: tag.name })
  }

  removeTagOnChatsView(tag: CodableTag) {
    void this.analytics.track('remove_tag_chats_view', { tagName: tag.name })
  }

  removeTagOnCallsView(tag: CodableTag) {
    void this.analytics.track('remove_tag_calls_view', { tagName: tag.name })
  }

  removeTagOnSettings(tag: CodableTag) {
    void this.analytics.track('remove_tag_settings', { tagName: tag.name })
  }

  addCallTag({ name, description }: { name: string; description: string }) {
    void this.analytics.track('add_call_tag', {
      tagName: name,
      tagDescription: description,
    })
  }

  editCallTag({
    previousTagName,
    previousTagDescription,
    newTagName,
    newTagDescription,
  }: {
    previousTagName: string
    previousTagDescription: string
    newTagName: string
    newTagDescription: string
  }) {
    void this.analytics.track('edit_call_tag', {
      previousTagName,
      previousTagDescription,
      newTagName,
      newTagDescription,
    })
  }

  toggleCallTag(enabled: boolean) {
    void this.analytics.track('toggle_call_tag', { enabled })
  }
}
